<ng-container rtBlock="sc-breadcrumbs">
    <nav rtElem="nav" aria-label="Breadcrumb" i18n-aria-label="@@breadcrumbsLabel">
        <ol rtElem="list">
            @for (item of items(); track $index) {
                <li rtElem="item">
                    @if (item.link) {
                        <a rtElem="link" [routerLink]="item.link">{{ item.label }}</a>
                    } @else {
                        <span rtElem="current">{{ item.label }}</span>
                    }
                    <span rtElem="sep" aria-hidden="true">/</span>
                </li>
            }
        </ol>
    </nav>
</ng-container>
